import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, BehaviorSubject, throwError } from 'rxjs';
import { catchError, switchMap, filter, take } from 'rxjs/operators';
import { AuthenticationService } from '../services/authentication.service';
import { EncryptionService } from '../services/crypt.service';
import { Router } from '@angular/router';

@Injectable()

export class JwtInterceptor implements HttpInterceptor {
  

  private REFRESH_INTERVAL = 5 * 60 * 1000; // 5  minutes
  private refreshing = false;
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null);

  constructor(
    private authService: AuthenticationService,
    private router: Router,
    private EncryptionService: EncryptionService
  ) { }

  private storeLastValidUrl(): void {
    const currentUrl = this.router.url;

    if (!currentUrl || currentUrl.includes('login') || currentUrl.includes('refresh')) {
      return;
    }
    
  }
  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = this.authService.getToken();

    // Pas de refresh pour login ou refresh
    if (!token || request.url.includes('/api/Login') || request.url.includes('/api/Login/refresh')) {
      return next.handle(request);
    }

    this.storeLastValidUrl();

    const now = Date.now();
    const lastRefresh = Number(
      this.EncryptionService.decrypt(
        sessionStorage.getItem('azda6864ad6a8zd4adqxsqsd5556azda46684ad68684azd4646vr64zg6644vf4g4e8g') || ''
      )
    ) || 0;

    const handleRequestWithToken = (tok: string) => {
      const clonedRequest = request.clone({ setHeaders: { Authorization: `Bearer ${tok}` } });

      return next.handle(clonedRequest).pipe(
        catchError(err => {
          if (err.status === 401) {
            this.authService.clearToken();
            this.router.navigateByUrl('login');
          }
          return throwError(() => err);
        })
      );
    };

    // Si dernière mise à jour récente → utiliser le token actuel
    if (now - lastRefresh < this.REFRESH_INTERVAL) {
      return handleRequestWithToken(token);
    }

    // Si un refresh est déjà en cours → attendre
    if (this.refreshing) {
      return this.refreshTokenSubject.pipe(
        filter(tok => tok !== null),
        take(1),
        switchMap(tok =>
          handleRequestWithToken(tok!)
        )
      );
    }

    // Lancer un refresh
    this.refreshing = true;
    this.refreshTokenSubject.next(null);

    return this.authService.refreshToken().pipe(
      switchMap((res: any) => {
        const newToken = res.token;
        this.authService.setToken(newToken);

        let ts = this.EncryptionService.encrypt(Date.now().toString());
        sessionStorage.setItem('azda6864ad6a8zd4adqxsqsd5556azda46684ad68684azd4646vr64zg6644vf4g4e8g', ts);

        this.refreshing = false;
        this.refreshTokenSubject.next(newToken);

        return handleRequestWithToken(newToken);
      }),
      catchError(err => {
        this.refreshing = false;
        this.refreshTokenSubject.next(null);
        this.authService.clearToken();
        this.router.navigateByUrl('login');
        return throwError(() => err);
      })
    );

  }
}
